import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Observable } from 'rxjs';
import { SpoFilters } from '../../../../models/filters/spo-filters-model';
import { Spo } from '../../../../models/spo-model';
import { addCheckers } from '../../../../shared/checkers.service';
import { ImportExportService } from '../../../../shared/import-export.service';
import { LotsService } from '../../../../shared/lots.service';
import { SposService } from '../../../../shared/spos.service';

@Component({
  selector: 'app-main-spos-list',
  templateUrl: './main-spos-list.component.html',
  styleUrls: ['./main-spos-list.component.css'],
})
export class MainSposListComponent implements OnInit {
  dataSource: MatTableDataSource<Spo>;

  displayedColumns = [
    'check',
    'code',
    'orderId',
    'supplier',
    'destination',
    'vendor',
    'lotName',
    'extra',
    'crossUkBorder',
    'earliestDeliveryDate',
    'latestDeliveryDate',
    'latestPickupDate',
    'requestedQuantity',
    'confirmedQuantity',
    'orderedQuantity',
    'requestedValue',
    'confirmedValue',
    'confirmedPurchasePrice',
    'virtualConfirmedPurchasePrice',
    'orderedValue',
    'orderedPurchasePrice',
    'virtualOrderedPurchasePrice',
    'margin',
    'percentMargin',
    'virtualMargin',
    'virtualPercentMargin',
    'virtualConfirmedMargin',
    'virtualConfirmedPercentMargin',
    'status',
  ];

  mainChecker = false;

  bulkActionsActive = false;

  dataSpo: any[] = [];

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  resultsNumber: Observable<number>;

  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(private sposService: SposService, private lotsService: LotsService, private importExportService: ImportExportService) {}

  ngOnInit() {
    this.lotsService.resetLotId();
    this.resultsNumber = this.sposService.resultsNumber;

    if (this.sposService.spoFilters === undefined) {
      this.sposService.spoFilters = new SpoFilters();
    }
    this.resetCheckers();
    this.dataSource = new MatTableDataSource([]);
    this.loadSpos(this.sposService.spoFilters);
  }

  loadSpos(filters: SpoFilters) {
    this.sposService.getFilteredSpos(undefined, filters).subscribe((spos: Spo[]) => {
      this.dataSpo = addCheckers(spos, this.sposService.selectedSpos, this.mainChecker);
      this.dataSource.data = this.dataSpo;
    });
  }

  loadPage() {
    this.sposService.spoFilters.pageNumber = this.paginator.pageIndex;
    this.sposService.spoFilters.pageSize = this.paginator.pageSize;
    this.loadSpos(this.sposService.spoFilters);
  }

  onSort() {
    this.sposService.spoFilters.sortBy = this.sort.active;
    this.sposService.spoFilters.sortDirection = this.sort.direction;
    this.loadSpos(this.sposService.spoFilters);
  }

  onSelected(value: boolean, selectedSpo: any) {
    const selectedIndex = this.dataSpo.indexOf(selectedSpo);
    this.dataSpo[selectedIndex].checked = value;
    if (value !== this.mainChecker) {
      this.sposService.addSpoIdToSelected(this.dataSpo[selectedIndex].id);
    } else {
      this.sposService.removeSpoIdFromSelected(this.dataSpo[selectedIndex].id);
    }
    this.bulkActionsActive = value || this.mainChecker;
  }

  toggleAll(value: boolean) {
    this.mainChecker = value;
    this.sposService.sposMainChecker = this.mainChecker;
    for (const i of this.dataSpo) {
      i.checked = value;
    }
    this.sposService.selectedSpos = [];
    this.bulkActionsActive = value;
  }

  onFilter(filters: SpoFilters) {
    this.paginator.pageIndex = 0;
    this.resetCheckers();
    this.loadSpos(filters);
  }

  resetCheckers() {
    this.sposService.selectedSpos = [];
    this.mainChecker = false;
    this.bulkActionsActive = false;
  }

  delete() {
    this.sposService
      .deleteSpos(this.sposService.selectedSpos, this.sposService.spoFilters, this.mainChecker, undefined)
      .subscribe((resp: boolean) => {
        if (resp) {
          this.paginator.pageIndex = 0;
          this.resetCheckers();
          this.loadSpos(this.sposService.spoFilters);
        } else {
          return;
        }
      });
  }

  export(format: string) {
    this.importExportService
      .exportSpos(this.sposService.selectedSpos, format, this.sposService.spoFilters, this.mainChecker, undefined)
      .subscribe((resp) => {
        console.log(resp);
      });
  }
}
